module.exports = __webpack_public_path__ + "img/gb923.prt.b1f8876d.jpg";